import KiqQuestion from './KiqQuestion';

export default KiqQuestion;
